export const AE_SYSTEM_COPY = {
	title: {
		add: 'Add complaint system',
		edit: 'Edit complaint system',
	},
	submit: {
		add: 'Add',
		edit: 'Save',
	},
	description:
		'Capture the tools where complaints are logged so intake channels and workflows stay connected.',
	fields: {
		platformLabel: 'What system or platform captures customer complaints?',
		nameLabel: 'What do you call this system internally?',
		usageLabel: 'How is this system used in the workflow?',
	},
	warnings: {
		nameMissing: 'Provide the system or tracker name.',
		usageMissing: 'Select at least one workflow usage.',
	},
	remove: {
		title: 'Remove this complaint system?',
		description: 'This system will be removed from the list.',
	},
}
